<template>
  <div>
    <el-card>
      <!-- 头部 -->
      <el-row :gutter="24">
        <el-col :span="8">
          <div style="font-size: 30px">
            项目检测报表&nbsp;&nbsp;&nbsp;
            <span style="font-size: 26px">{{ time }}</span>
          </div>
        </el-col>
        <el-col :span="6" class="flex" style="margin-top: 10px">
          <div style="font-size: 20px">总体进度</div>
          <div style="width: 70%; padding-left: 10px">
            <el-progress
              :text-inside="true"
              :stroke-width="26"
              :percentage="zhanbi"
            ></el-progress>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="22" :offset="0" style="font-size: 16px; margin: 10px 0">
          共20个项目，已完成张0个，未完成20个
        </el-col>
      </el-row>
      <!-- echarts -->
      <el-row :gutter="24">
        <el-col :span="7">
          <v-chart
            theme="macarons"
            id="chart1"
            style="width: 100%"
            :options="polar"
          ></v-chart>
        </el-col>
        <el-col :span="7">
          <v-chart
            theme="macarons"
            id="chart1"
            style="width: 100%"
            :options="polar2"
          ></v-chart>
        </el-col>
        <el-col :span="10">
          <v-chart
            theme="macarons"
            id="chart1"
            style="width: 100%"
            :options="polar3"
          ></v-chart>
        </el-col>
      </el-row>
      <!-- 表格 -->
      <el-row :gutter="24">
        <el-table
          :data="tableList"
          max-height="450px"
          height="450px"
          style="width: 100%"
        >
          <el-table-column property="name" label="项目名称" width="180">
          </el-table-column>
          <el-table-column property="manager" label="BIM负责人" width="180">
          </el-table-column>
          <el-table-column property="startTime" label="计划开工时间">
          </el-table-column>
          <el-table-column property="endTime" label="计划竣工时间">
          </el-table-column>
          <el-table-column property="truth" label="实际"> </el-table-column>
          <el-table-column property="target" label="指标"> </el-table-column>
          <el-table-column property="complete" label="完成率">
          </el-table-column>
        </el-table>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { ProjectReport } from "@/setAxios";
export default {
  data() {
    return {
      time: new Date().toLocaleString("chinese", { hour12: false }),
      polar: {},
      polar2: {},
      polar3: {},
      tableList: [],
      ycsj: 0,
      wbsj: 0,
      sdsj: 0,
      zyNameList: [],
      zhanbi: 0,
    };
  },
  created() {
    this.ProjectReport();
  },
  mounted() {
    setInterval(() => {
      this.time = new Date().toLocaleString("chinese", { hour12: false });
    }, 1000);
  },
  methods: {
    async ProjectReport() {
      let that = this;
      let params = {
        cid: localStorage.pid,
      };
      let res = await ProjectReport({ params });
      this.tableList = res.Data;
      let a = 0;
      let b = 0;
      this.tableList.forEach((ele) => {
        let bool = true;
        this.zyNameList.forEach((ele2, index2) => {
          if (ele.major == ele2.name) {
            ele2.num++;
            bool = false;
          }
        });
        if (bool) {
          this.zyNameList.push({
            name: ele.major,
            num: 1,
          });
        }
        a += ele.truth;
        b += ele.target;
        switch (ele.type) {
          case "一次设计":
            this.ycsj++;
            break;
          case "外包设计":
            this.wbsj++;
            break;
          default:
            this.sdsj++;
        }
      });
      this.zhanbi = (a / b) * 100;
      this.polar = {
        title: {
          text: "项目类型分析",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: 10,
          data: ["一次设计", "外包设计", "深度设计"],
        },
        series: [
          {
            name: "类型",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: this.ycsj, name: "一次设计" },
              { value: this.wbsj, name: "外包设计" },
              { value: this.sdsj, name: "深度设计" },
            ],
          },
        ],
      };
      this.polar2 = {
        title: {
          text: "项目所属专业分析",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: 10,
          data: (function () {
            let arr = [];
            that.zyNameList.forEach((ele) => {
              arr.push(ele.name);
            });
            return arr;
          })(),
        },
        series: [
          {
            name: "类型",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: (function () {
              let arr = [];
              that.zyNameList.forEach((ele) => {
                let option = { value: Math.floor(ele.num), name: ele.name };
                arr.push(option);
              });
              return arr;
            })(),
          },
        ],
      };
      this.polar3 = {
        title: {
          text: "项目完成率",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}:{c}%",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: (function () {
            let arr = [];
            that.tableList.forEach((ele) => {
              if (ele.truth !== 0) arr.push(ele.name);
            });
            arr = arr.reverse();
            return arr;
          })(),
        },
        series: [
          {
            type: "bar",
            data: (function () {
              let arr = [];
              that.tableList.forEach((ele) => {
                if (ele.truth !== 0)
                  arr.push(Math.floor((ele.truth / ele.target) * 100));
              });
              arr = arr.reverse();
              return arr;
            })(),
          },
        ],
      };
    },
  },
};
</script>

<style lang="scss">
.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
</style>